module.exports = __webpack_public_path__ + "img/pic_empty_course@2x.50cf56b5.png";